import {createCookie} from 'ubs-framework/v2/common/cookie';
import {constant} from "../../common/constant";
import {planMerger} from 'ubs-framework/v2/common/convert';

const initialState = {
    socketConnection: false,
    token: '',
    email: '',
    S3_BASE_URL: '',
    isAuthenticated: false,
    errorObject: {},
    isAdmin: false,
    logInDetails: {},
    forgotRecoveryUser: ''
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION':
            return {...state, socketConnection: action.payload}
        case 'ON_BOARDING_AUTHENTICATE': {
            const data = {}
            if (action.payload) {
                data.S3_BASE_URL = action.payload.S3_BASEURL
            }
            return {...state,...data,...action.payload};
        }
        case 'LOGIN':
            const planAccess = planMerger(action.payload?.planAccess, action.payload?.productAccess, action.payload?.isAdmin)
            createCookie('ubs_token', action.payload.token, constant.COOKIE_DAYS)
            return {...state, ...action.payload, planAccess};
        case 'SET_LOG_IN_DETAILS':
            return {...state, logInDetails: action.payload};
        case 'SET_FORGOT_RECOVERY_USER':
            return {...state, forgotRecoveryUser: action.payload};
        case 'AUTHENTICATE': {
            const data = {isAuthenticated: !!action.payload, authData: action?.payload}
            if (action.payload) {
                data.S3_BASE_URL = action.payload.S3_BASEURL
            }   
            return {...state,...data}

        }
        case 'SET_EMAIL':
            return {...state, email: action.payload};
        case 'SET_IS_ADMIN':
            return {...state, isAdmin: action.payload};
        case 'ERROR':
            return {...state, errorObject: action.payload}
        case 'LOGOUT':
            return {
                socketConnection: false,
                token: '',
                email: '',
                isAuthenticated: false,
                errorObject: {},
            }
        default:
            return state;
    }
}
